import { useState, useRef, useEffect } from "react";
import { cleanJoin } from "../../utils/stringUtil";
import { isMobile } from "../../utils/screenUtil";
const Dropdown = ({ button, children }) => {
  const [isActive, setIsActive] = useState(false);

  const dropdownRef = useRef();
  const buttonRef = useRef();

  // Track events outside scope
  const clickOutside = (e) => {
    // Clicked inside dropdown div
    if (dropdownRef.current.contains(e.target) || buttonRef.current.contains(e.target)) {
      return;
    } else if (!dropdownRef.current.contains(e.target))
      // outside outside dropdown div
      setIsActive(false);
  };

  // Do something after component renders
  useEffect(() => {
    document.addEventListener("mousedown", clickOutside);
    // clean up function before running new effect
    return () => {
      document.removeEventListener("mousedown", clickOutside);
    };
  }, [isActive]);

  const titleStyle = {
    border: "1px solid #ccc",
    borderRadius: "5px",
    minWidth: "250px",
  };
  return (
    <>
      <div
        className={cleanJoin(
          "dropdown",
          isActive ? "is-active" : "",
          isMobile() ? "is-left" : "is-right"
        )}
      >
        <div className="dropdown-trigger" ref={buttonRef} onClick={() => setIsActive(!isActive)}>
          {button()}
        </div>
        <div className="dropdown-menu" id="dropdown-menu3" role="menu" ref={dropdownRef}>
          <div style={titleStyle} className="dropdown-content p-0">
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export default Dropdown;
